<div class="signupContent">
    <form class="login100-form validate-form">
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="email" name="email" placeholder="Email">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="container-login100-form-btn">
            <button class="login100-form-btn" (click)="send()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                Envoyer
            </button>
        </div>
        <div class="footer justify-content-between">
            <p>
                Merci de consulter votre boite e-mail pour obtenir votre mot de passe.
            </p>
            <button routerLink="../../connexion" class="login-btn">
                Se connecter &nbsp;&nbsp;
                <i class="glyphicon glyphicon-arrow-right"></i>
            </button>
        </div>
    </form>
</div>